import { GetItFixedButton, UserFeedback, ChecksFeedback } from 'components'
import { CheckUtils } from 'utils'

export default class V3Check extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object,
  }

  static propTypes = {
    check:             React.PropTypes.object.isRequired,
    advisor:           React.PropTypes.object.isRequired,
    result:            React.PropTypes.object.isRequired,
    isEnjoying:        React.PropTypes.bool,
    willReview:        React.PropTypes.bool,
    willFeedback:      React.PropTypes.bool,
    feedbackDismissed: React.PropTypes.bool,
  }

  renderChecksSupportForm() {
    if (!['seoproblems', 'blog'].includes(this.props.advisor.key)) return null

    const surveyLink = this.props.advisor.surveyLinks[this.context.currentUser.activeCharge ? 'plus' : 'free']

    return (
      <ChecksFeedback
        href={surveyLink}
        featureType={this.props.advisor.key}
      />
    )
  }

  renderPassIntro() {
    return (
      <div>
        <h3>You've passed this check</h3>
        <p>Your advisor hasn't found any action points for you on this check. But read below to learn best practice.</p>
      </div>
    )
  }
  renderFailIntro() {
    return this.props.failIntro && this.props.failIntro() || <h3>What's wrong</h3>
  }

  renderIntro() {
    return (this.props.check.severity == "Pass") &&
      this.renderPassIntro() ||
      this.renderFailIntro()
  }

  renderDetails() {
    return this.props.details && this.props.details() || ""
  }

  renderFeedback() {
    return (
      <div>
        <UserFeedback
          feedbackDismissed={this.props.feedbackDismissed}
          isEnjoying={this.props.isEnjoying}
          willReview={this.props.willReview}
          willFeedback={this.props.willFeedback} />
        <hr/>
      </div>
    )
  }

  renderGetItFixed() {
    return (
      <div className="xlarge-spacing2--top">
        <GetItFixedButton
          checkType={this.props.advisor}
          result={this.props.result}
          pageLocation="bottom"
        />
      </div>
    )
  }

  renderHeader() {
    return <h2 className="details__content__header">How to Fix Your {CheckUtils.friendlyTitle(this.props.check.title)}</h2>
  }

  render() {
    return (
      <div>
        { this.renderHeader() }
        <div className="details__content__checks">
          { this.renderIntro() }
          { this.renderDetails() }
          { this.renderFeedback() }
          { this.props.info() }
        </div>
        {this.renderChecksSupportForm()}
        { this.renderGetItFixed()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/v3_checks/V3Check.js